<template>
    <v-container class="pa-5" fluid>
        <NotificationDialog
            :is-open="saveNotificationDialog"
            :action-name="actionName"
            :dock-reservation-title="dockReservationTitle"
            :component-name="$options.name"
            :current-dock-reservation="currentDockReservation"
            @close-notification-dialog="closeNotificationDialog"
        />
        <page-title>Awizacje</page-title>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <FullCalendar
                        v-if="dockReservationsLoading"
                        ref="fullCalendar"
                        class="fc fc-ltr fc-unthemed fc-colours"
                        :options="{
                            ...calendarOptions,
                            resources: docks,
                            events: dockReservations,
                            slotMinTime: minTime,
                            slotMaxTime: maxTime,
                            slotDuration: slotDurationGateHouse
                        }"
                    />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import FullCalendar from '@fullcalendar/vue'
import interaction from '@fullcalendar/interaction'
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid'
import { errorHandler } from '@/utils/errorHandler'
import calendar from '@/mixins/calendar'
import NotificationDialog from '@/views/Shipping/Notification/NotificationDialog'
import store from '@/store'
import { appConfig } from '@/config'


export default {
    name: 'NotificationGateHouse',
    components: {
        PageTitle,
        FullCalendar,
        NotificationDialog
    },
    mixins: [ calendar ],
    beforeRouteEnter(to, from, next) {
        store.dispatch('shipping/notification/clearDocks')
        next()
    },
    data() {
        return {
            dockReservationsLoading: false,
            calendarOptions: {
                plugins: [interaction, resourceTimeGridPlugin],
                schedulerLicenseKey: appConfig.common.schedulerLicenseKey,
                customButtons: {
                    prev: {
                        text: 'prev',
                        click: () => this.getDataOnWeekChangeButton('prev')
                    },
                    next: {
                        text: 'next',
                        click: () => this.getDataOnWeekChangeButton('next')
                    }
                },
                headerToolbar: {
                    left: '',
                    center: 'title',
                    right: ''
                },
                initialView: 'resourceTimeGridDay',
                allDaySlot: false,
                firstDay: 1,
                slotLabelFormat: {hour: 'numeric', minute: '2-digit', hour12: false},
                locale: 'pl',
                displayEventTime: false,
                loading: this.dockReservationsLoading,
                selectable: true,
                eventClick: this.showNotificationDialog,
                eventDidMount: this.eventRender
            },
            saveNotificationDialog: false,
            deleteNotificationDialog: false,
            dockReservationTitle: null,
            actionName: null,
            user: null,
            currentDockReservation: {
                info: null,
                dockReservationData: null
            },

        }
    },
    computed: {
        dockReservations() {
            return this.$store.state.shipping.notification.notification.dockReservations.filter(reservation => reservation.dockReservationStatusId === 20)
        },
        docks() {
            return this.$store.state.shipping.notification.notification.docks
        },
        minTime() {
            return appConfig.shipping.notification.minTime
        },
        maxTime() {
            return appConfig.shipping.notification.maxTime
        },
        slotDurationGateHouse() {
            return appConfig.shipping.notification.slotDurationGateHouse
        }
    },
    mounted() {
        this.$store.dispatch('shipping/notification/getDocksDicts', {query: '', dockType: null})
            .then(() => {
                this.getDockReservations(this.currentWeekDateRange())
            })
            .catch(error => {
                errorHandler(error)
            })
            .finally(() => {
                this.dockReservationsLoading = true
            })
    },
    methods: {
        async getDockReservation(dockReservationId) {
            return await this.$store.dispatch('shipping/notification/getDockReservation', dockReservationId)
                .then(response => {
                    this.currentDockReservation.dockReservationData = response.data
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        getDockReservations(weekRange) {
            this.$store.dispatch('shipping/notification/getDockReservations', {query: `?start=${weekRange[0]}&end=${weekRange[weekRange.length-1]}`})
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.dockReservationsLoading = true
                })
        },
        showNotificationDialog(info) {
            this.getDockReservation(parseInt(info.event.id)).then(() => {
                this.currentDockReservation.info = info
                this.saveNotificationDialog = true
                this.actionName = 'openDockReservation'
                this.dockReservationTitle = 'Szczegóły rezerwacji'
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        updateCalendarView() {
            this.getDockReservations(this.generateWeekRange(this.$refs.fullCalendar.getApi().view.activeStart))
        },
        closeNotificationDialog() {
            this.saveNotificationDialog = false
            this.updateCalendarView()
        }
    }
}

</script>

